/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeSurveyExecutionsResponseDto } from '../models';
// @ts-ignore
import type { ExecutionAnswersResponseDto } from '../models';
// @ts-ignore
import type { ExecutionCategoriesBelowThresholdResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SurveyAssignmentStatusDto } from '../models';
// @ts-ignore
import type { SurveyDetailDto } from '../models';
// @ts-ignore
import type { SurveyExecutionStatusDto } from '../models';
// @ts-ignore
import type { SurveyListResponseDto } from '../models';
// @ts-ignore
import type { SurveyParticipantsResponseDto } from '../models';
// @ts-ignore
import type { SurveyReportTypeDto } from '../models';
// @ts-ignore
import type { SurveyStatusDto } from '../models';
// @ts-ignore
import type { UpdateSurveyRequestDto } from '../models';
/**
 * SurveyManagementApi - axios parameter creator
 * @export
 */
export const SurveyManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get survey executions for a specific employee with pagination and filters
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [surveyName] Filter by survey name (partial match)
         * @param {SurveyStatusDto} [surveyStatus] Filter by survey status
         * @param {SurveyExecutionStatusDto} [executionStatus] Filter by execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSurveyExecutions: async (employeeId: string, page?: number, pageSize?: number, surveyName?: string, surveyStatus?: SurveyStatusDto, executionStatus?: SurveyExecutionStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeSurveyExecutions', 'employeeId', employeeId)
            const localVarPath = `/api/v2/surveys/executions/employee/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (surveyName !== undefined) {
                localVarQueryParameter['surveyName'] = surveyName;
            }

            if (surveyStatus !== undefined) {
                localVarQueryParameter['surveyStatus'] = surveyStatus;
            }

            if (executionStatus !== undefined) {
                localVarQueryParameter['executionStatus'] = executionStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of all answers for a specific survey and employee. Useful for administrators to review all responses. 
         * @summary Get all answers for survey and employee with pagination
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [areaName] Filter by area name (exact match)
         * @param {number} [categoryId] Filter by category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionAnswers: async (surveyId: number, employeeId: string, page?: number, pageSize?: number, areaName?: string, categoryId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getExecutionAnswers', 'surveyId', surveyId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getExecutionAnswers', 'employeeId', employeeId)
            const localVarPath = `/api/v2/surveys/{surveyId}/employees/{employeeId}/answers`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (areaName !== undefined) {
                localVarQueryParameter['areaName'] = areaName;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get categories below pass threshold for survey and employee
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionCategoriesBelowThreshold: async (surveyId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getExecutionCategoriesBelowThreshold', 'surveyId', surveyId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getExecutionCategoriesBelowThreshold', 'employeeId', employeeId)
            const localVarPath = `/api/v2/surveys/{surveyId}/employees/{employeeId}/categories/below-threshold`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates an Excel report for a survey based on the report type. If employeeId is provided, returns data for that specific employee. If employeeId is omitted, returns data for all employees. 
         * @summary Download Excel report for survey execution
         * @param {number} surveyId 
         * @param {SurveyReportTypeDto} reportType Type of report to generate
         * @param {string} [employeeId] Employee ID. If provided, report is for this employee only. If omitted, report includes all employees.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionReportExcel: async (surveyId: number, reportType: SurveyReportTypeDto, employeeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getExecutionReportExcel', 'surveyId', surveyId)
            // verify required parameter 'reportType' is not null or undefined
            assertParamExists('getExecutionReportExcel', 'reportType', reportType)
            const localVarPath = `/api/v2/surveys/{surveyId}/report/excel`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey detail with all questions, scales, and categories
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetail: async (surveyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurveyDetail', 'surveyId', surveyId)
            const localVarPath = `/api/v2/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey participants with pagination
         * @param {number} surveyId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Free-text search across first name, last name and email.
         * @param {SurveyAssignmentStatusDto} [status] Filter by survey assignment status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyParticipants: async (surveyId: number, page?: number, pageSize?: number, search?: string, status?: SurveyAssignmentStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurveyParticipants', 'surveyId', surveyId)
            const localVarPath = `/api/v2/surveys/{surveyId}/participants`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all surveys with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [filter] 
         * @param {string} [employeeId] Filter surveys assigned to specific employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys: async (page?: number, pageSize?: number, filter?: string, employeeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates survey properties. When status changes from NEW to IN_PROGRESS: - Survey participants (executions) are created for all assigned employees - Notifications are sent to all participants 
         * @summary Update survey (name, status, deadline)
         * @param {number} surveyId 
         * @param {UpdateSurveyRequestDto} updateSurveyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: async (surveyId: number, updateSurveyRequestDto: UpdateSurveyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('updateSurvey', 'surveyId', surveyId)
            // verify required parameter 'updateSurveyRequestDto' is not null or undefined
            assertParamExists('updateSurvey', 'updateSurveyRequestDto', updateSurveyRequestDto)
            const localVarPath = `/api/v2/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSurveyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyManagementApi - functional programming interface
 * @export
 */
export const SurveyManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get survey executions for a specific employee with pagination and filters
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [surveyName] Filter by survey name (partial match)
         * @param {SurveyStatusDto} [surveyStatus] Filter by survey status
         * @param {SurveyExecutionStatusDto} [executionStatus] Filter by execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSurveyExecutions(employeeId: string, page?: number, pageSize?: number, surveyName?: string, surveyStatus?: SurveyStatusDto, executionStatus?: SurveyExecutionStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeSurveyExecutionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSurveyExecutions(employeeId, page, pageSize, surveyName, surveyStatus, executionStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getEmployeeSurveyExecutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of all answers for a specific survey and employee. Useful for administrators to review all responses. 
         * @summary Get all answers for survey and employee with pagination
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [areaName] Filter by area name (exact match)
         * @param {number} [categoryId] Filter by category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutionAnswers(surveyId: number, employeeId: string, page?: number, pageSize?: number, areaName?: string, categoryId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutionAnswersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutionAnswers(surveyId, employeeId, page, pageSize, areaName, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getExecutionAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get categories below pass threshold for survey and employee
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutionCategoriesBelowThreshold(surveyId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutionCategoriesBelowThresholdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutionCategoriesBelowThreshold(surveyId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getExecutionCategoriesBelowThreshold']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates an Excel report for a survey based on the report type. If employeeId is provided, returns data for that specific employee. If employeeId is omitted, returns data for all employees. 
         * @summary Download Excel report for survey execution
         * @param {number} surveyId 
         * @param {SurveyReportTypeDto} reportType Type of report to generate
         * @param {string} [employeeId] Employee ID. If provided, report is for this employee only. If omitted, report includes all employees.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutionReportExcel(surveyId: number, reportType: SurveyReportTypeDto, employeeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutionReportExcel(surveyId, reportType, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getExecutionReportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey detail with all questions, scales, and categories
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyDetail(surveyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyDetail(surveyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey participants with pagination
         * @param {number} surveyId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Free-text search across first name, last name and email.
         * @param {SurveyAssignmentStatusDto} [status] Filter by survey assignment status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyParticipants(surveyId: number, page?: number, pageSize?: number, search?: string, status?: SurveyAssignmentStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyParticipants(surveyId, page, pageSize, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all surveys with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [filter] 
         * @param {string} [employeeId] Filter surveys assigned to specific employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveys(page?: number, pageSize?: number, filter?: string, employeeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveys(page, pageSize, filter, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates survey properties. When status changes from NEW to IN_PROGRESS: - Survey participants (executions) are created for all assigned employees - Notifications are sent to all participants 
         * @summary Update survey (name, status, deadline)
         * @param {number} surveyId 
         * @param {UpdateSurveyRequestDto} updateSurveyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurvey(surveyId: number, updateSurveyRequestDto: UpdateSurveyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurvey(surveyId, updateSurveyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.updateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyManagementApi - factory interface
 * @export
 */
export const SurveyManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Get survey executions for a specific employee with pagination and filters
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [surveyName] Filter by survey name (partial match)
         * @param {SurveyStatusDto} [surveyStatus] Filter by survey status
         * @param {SurveyExecutionStatusDto} [executionStatus] Filter by execution status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSurveyExecutions(employeeId: string, page?: number, pageSize?: number, surveyName?: string, surveyStatus?: SurveyStatusDto, executionStatus?: SurveyExecutionStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSurveyExecutionsResponseDto> {
            return localVarFp.getEmployeeSurveyExecutions(employeeId, page, pageSize, surveyName, surveyStatus, executionStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of all answers for a specific survey and employee. Useful for administrators to review all responses. 
         * @summary Get all answers for survey and employee with pagination
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [areaName] Filter by area name (exact match)
         * @param {number} [categoryId] Filter by category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionAnswers(surveyId: number, employeeId: string, page?: number, pageSize?: number, areaName?: string, categoryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionAnswersResponseDto> {
            return localVarFp.getExecutionAnswers(surveyId, employeeId, page, pageSize, areaName, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get categories below pass threshold for survey and employee
         * @param {number} surveyId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionCategoriesBelowThreshold(surveyId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionCategoriesBelowThresholdResponseDto> {
            return localVarFp.getExecutionCategoriesBelowThreshold(surveyId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates an Excel report for a survey based on the report type. If employeeId is provided, returns data for that specific employee. If employeeId is omitted, returns data for all employees. 
         * @summary Download Excel report for survey execution
         * @param {number} surveyId 
         * @param {SurveyReportTypeDto} reportType Type of report to generate
         * @param {string} [employeeId] Employee ID. If provided, report is for this employee only. If omitted, report includes all employees.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionReportExcel(surveyId: number, reportType: SurveyReportTypeDto, employeeId?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getExecutionReportExcel(surveyId, reportType, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey detail with all questions, scales, and categories
         * @param {number} surveyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetail(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailDto> {
            return localVarFp.getSurveyDetail(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey participants with pagination
         * @param {number} surveyId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Free-text search across first name, last name and email.
         * @param {SurveyAssignmentStatusDto} [status] Filter by survey assignment status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyParticipants(surveyId: number, page?: number, pageSize?: number, search?: string, status?: SurveyAssignmentStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyParticipantsResponseDto> {
            return localVarFp.getSurveyParticipants(surveyId, page, pageSize, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all surveys with pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [filter] 
         * @param {string} [employeeId] Filter surveys assigned to specific employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys(page?: number, pageSize?: number, filter?: string, employeeId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyListResponseDto> {
            return localVarFp.getSurveys(page, pageSize, filter, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates survey properties. When status changes from NEW to IN_PROGRESS: - Survey participants (executions) are created for all assigned employees - Notifications are sent to all participants 
         * @summary Update survey (name, status, deadline)
         * @param {number} surveyId 
         * @param {UpdateSurveyRequestDto} updateSurveyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey(surveyId: number, updateSurveyRequestDto: UpdateSurveyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailDto> {
            return localVarFp.updateSurvey(surveyId, updateSurveyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyManagementApi - interface
 * @export
 * @interface SurveyManagementApi
 */
export interface SurveyManagementApiInterface {
    /**
     * 
     * @summary Get survey executions for a specific employee with pagination and filters
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [surveyName] Filter by survey name (partial match)
     * @param {SurveyStatusDto} [surveyStatus] Filter by survey status
     * @param {SurveyExecutionStatusDto} [executionStatus] Filter by execution status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getEmployeeSurveyExecutions(employeeId: string, page?: number, pageSize?: number, surveyName?: string, surveyStatus?: SurveyStatusDto, executionStatus?: SurveyExecutionStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSurveyExecutionsResponseDto>;

    /**
     * Returns paginated list of all answers for a specific survey and employee. Useful for administrators to review all responses. 
     * @summary Get all answers for survey and employee with pagination
     * @param {number} surveyId 
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [areaName] Filter by area name (exact match)
     * @param {number} [categoryId] Filter by category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getExecutionAnswers(surveyId: number, employeeId: string, page?: number, pageSize?: number, areaName?: string, categoryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionAnswersResponseDto>;

    /**
     * 
     * @summary Get categories below pass threshold for survey and employee
     * @param {number} surveyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getExecutionCategoriesBelowThreshold(surveyId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionCategoriesBelowThresholdResponseDto>;

    /**
     * Generates an Excel report for a survey based on the report type. If employeeId is provided, returns data for that specific employee. If employeeId is omitted, returns data for all employees. 
     * @summary Download Excel report for survey execution
     * @param {number} surveyId 
     * @param {SurveyReportTypeDto} reportType Type of report to generate
     * @param {string} [employeeId] Employee ID. If provided, report is for this employee only. If omitted, report includes all employees.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getExecutionReportExcel(surveyId: number, reportType: SurveyReportTypeDto, employeeId?: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get survey detail with all questions, scales, and categories
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getSurveyDetail(surveyId: number, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailDto>;

    /**
     * 
     * @summary Get survey participants with pagination
     * @param {number} surveyId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Free-text search across first name, last name and email.
     * @param {SurveyAssignmentStatusDto} [status] Filter by survey assignment status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getSurveyParticipants(surveyId: number, page?: number, pageSize?: number, search?: string, status?: SurveyAssignmentStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyParticipantsResponseDto>;

    /**
     * 
     * @summary Get all surveys with pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [filter] 
     * @param {string} [employeeId] Filter surveys assigned to specific employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    getSurveys(page?: number, pageSize?: number, filter?: string, employeeId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SurveyListResponseDto>;

    /**
     * Updates survey properties. When status changes from NEW to IN_PROGRESS: - Survey participants (executions) are created for all assigned employees - Notifications are sent to all participants 
     * @summary Update survey (name, status, deadline)
     * @param {number} surveyId 
     * @param {UpdateSurveyRequestDto} updateSurveyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApiInterface
     */
    updateSurvey(surveyId: number, updateSurveyRequestDto: UpdateSurveyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailDto>;

}

/**
 * SurveyManagementApi - object-oriented interface
 * @export
 * @class SurveyManagementApi
 * @extends {BaseAPI}
 */
export class SurveyManagementApi extends BaseAPI implements SurveyManagementApiInterface {
    /**
     * 
     * @summary Get survey executions for a specific employee with pagination and filters
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [surveyName] Filter by survey name (partial match)
     * @param {SurveyStatusDto} [surveyStatus] Filter by survey status
     * @param {SurveyExecutionStatusDto} [executionStatus] Filter by execution status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getEmployeeSurveyExecutions(employeeId: string, page?: number, pageSize?: number, surveyName?: string, surveyStatus?: SurveyStatusDto, executionStatus?: SurveyExecutionStatusDto, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getEmployeeSurveyExecutions(employeeId, page, pageSize, surveyName, surveyStatus, executionStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of all answers for a specific survey and employee. Useful for administrators to review all responses. 
     * @summary Get all answers for survey and employee with pagination
     * @param {number} surveyId 
     * @param {string} employeeId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [areaName] Filter by area name (exact match)
     * @param {number} [categoryId] Filter by category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getExecutionAnswers(surveyId: number, employeeId: string, page?: number, pageSize?: number, areaName?: string, categoryId?: number, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getExecutionAnswers(surveyId, employeeId, page, pageSize, areaName, categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get categories below pass threshold for survey and employee
     * @param {number} surveyId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getExecutionCategoriesBelowThreshold(surveyId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getExecutionCategoriesBelowThreshold(surveyId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates an Excel report for a survey based on the report type. If employeeId is provided, returns data for that specific employee. If employeeId is omitted, returns data for all employees. 
     * @summary Download Excel report for survey execution
     * @param {number} surveyId 
     * @param {SurveyReportTypeDto} reportType Type of report to generate
     * @param {string} [employeeId] Employee ID. If provided, report is for this employee only. If omitted, report includes all employees.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getExecutionReportExcel(surveyId: number, reportType: SurveyReportTypeDto, employeeId?: string, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getExecutionReportExcel(surveyId, reportType, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey detail with all questions, scales, and categories
     * @param {number} surveyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyDetail(surveyId: number, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyDetail(surveyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey participants with pagination
     * @param {number} surveyId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Free-text search across first name, last name and email.
     * @param {SurveyAssignmentStatusDto} [status] Filter by survey assignment status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyParticipants(surveyId: number, page?: number, pageSize?: number, search?: string, status?: SurveyAssignmentStatusDto, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyParticipants(surveyId, page, pageSize, search, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all surveys with pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [filter] 
     * @param {string} [employeeId] Filter surveys assigned to specific employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveys(page?: number, pageSize?: number, filter?: string, employeeId?: string, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveys(page, pageSize, filter, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates survey properties. When status changes from NEW to IN_PROGRESS: - Survey participants (executions) are created for all assigned employees - Notifications are sent to all participants 
     * @summary Update survey (name, status, deadline)
     * @param {number} surveyId 
     * @param {UpdateSurveyRequestDto} updateSurveyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public updateSurvey(surveyId: number, updateSurveyRequestDto: UpdateSurveyRequestDto, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).updateSurvey(surveyId, updateSurveyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

